import type { FunctionComponent } from "react";
import CampaignPostsAdminPartial from "../../../partials/admin/home/campaign-posts/campaign-posts.admin.partials";
import { PostStatus } from "../../../types/models/post.models.types";
import { useParams } from "react-router-dom";

export const CampaignPostSubmissionsAdminScreen: FunctionComponent = () => {
	const { campaignId } = useParams();

	if (!campaignId) {
		throw new Error("campaign id not found");
	}

	return (
		<CampaignPostsAdminPartial
			tabs={[
				{
					status: PostStatus.post,
					title: "Pending approval",
					flagged: false,
				},
				{
					status: PostStatus.postRejected,
					title: "Rejected",
					flagged: false,
				},
			]}
			initialStatus={PostStatus.post}
			campaignId={campaignId}
		/>
	);
};
